import React from 'react';
import './DetalleEmpleo.css';
import { Container, Row, Col, Card, Badge, Accordion } from 'react-bootstrap';
import { FaInfoCircle, FaClock, FaGraduationCap, FaCalendarAlt, FaBriefcase, FaCheckCircle, FaFileAlt, FaTimes } from 'react-icons/fa';
import escudo from '../../Images/Escudo.png';

const DetalleEmpleo = () => {

  const handleVerBases = () => {
    // Abrir el PDF de las bases en nueva pestaña para visualizar
    window.open('/uploads/empleo/Bases1.pdf', '_blank');
  };

  const handleVerResolucion = () => {
    // Abrir el PDF de la resolución en nueva pestaña para visualizar
    window.open('/uploads/empleo/Resolucion.pdf', '_blank');
  };

  return (
    <section className="detalle-empleo-section">
      <Container>
        {/* Header de la oferta */}
        <div className="detalle-header">
          <Row className="align-items-center mb-4">
            <Col md={2} className="text-center mb-3 mb-md-0">
              <img src={escudo} alt="Escudo Ayuntamiento" className="escudo-detalle" />
            </Col>
            <Col md={8}>
              <h1 className="detalle-titulo">Auxiliar de Ayuda a Domicilio</h1>
              <p className="detalle-subtitulo">Ayuntamiento de Escalonilla (Toledo)</p>
              <div className="detalle-info-basica">
                <div className="info-item">
                  <FaBriefcase className="info-icon" />
                  <span>Modalidad: Temporal</span>
                </div>
                <div className="info-item">
                  <FaCalendarAlt className="info-icon" />
                  <span>Publicado: Octubre 2025</span>
                </div>
                <div className="info-item">
                  <FaClock className="info-icon" />
                  <span>Plazo: Finalizado (20/10/2025)</span>
                </div>
              </div>
            </Col>
            <Col md={2} className="text-center">
              <Badge bg="success" className="estado-badge-detalle">
                ACTA DEFINITIVA PUBLICADA
              </Badge>
            </Col>
          </Row>
        </div>

        {/* Contenido principal */}
        <Row className="row-responsive">
          {/* Sidebar - Último en móviles, derecha en desktop */}
          <Col lg={4} className="order-2 order-lg-2 mb-4 mb-lg-0">
            <div className="sidebar-solicitud sticky-top">
              <Card className="solicitar-card">
                <Card.Body className="text-center">
                  <h4 className="mb-3">Estado del Proceso</h4>
                  <Badge bg="success" className="mb-3 p-2 fs-6">
                    ACTA DEFINITIVA PUBLICADA
                  </Badge>
                  <p className="mb-4">Se ha publicado el acta definitiva de puntuaciones. Se propone la contratación por orden decreciente cuando sea necesaria la cobertura de una interinidad.</p>
                  
                  <button 
                    className="btn btn-primary btn-lg btn-ver-bases-primario w-100 mb-3"
                    onClick={handleVerBases}
                  >
                    <FaFileAlt className="me-2" />
                    Ver Bases Completas
                  </button>

                  <button 
                    className="btn btn-outline-primary btn-lg btn-ver-bases w-100"
                    onClick={handleVerResolucion}
                  >
                    <FaFileAlt className="me-2" />
                    Ver Resolución
                  </button>
                </Card.Body>
              </Card>
            </div>
          </Col>

          <Col lg={8} className="contenido-principal order-1 order-lg-1">
            {/* Listado de aspirantes */}
            <Card className="info-card mb-4">
              <Card.Body>
                <h3><FaInfoCircle className="me-2" />Listado Definitivo de Aspirantes</h3>

                {/* Aspirantes Admitidos con Puntuaciones */}
                <div className="mb-4">
                  <h5 className="text-success mb-3">
                    <FaCheckCircle className="me-2" />
                    ACTA DEFINITIVA DE PUNTUACIONES
                  </h5>
                  <div className="alert alert-info mb-3">
                    <strong>Ordenados de mayor a menor puntuación</strong>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-striped table-hover">
                      <thead className="table-success">
                        <tr>
                          <th>Posición</th>
                          <th>Apellidos y Nombre</th>
                          <th>Identidad</th>
                          <th>Puntuación</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="table-warning">
                          <td><strong>1º</strong></td>
                          <td><strong>Díaz Garrido, Catalina</strong></td>
                          <td>***9848**</td>
                          <td><strong className="text-success">6,34</strong></td>
                        </tr>
                        <tr>
                          <td>2º</td>
                          <td>Magadán Gallardo, Mª Susana</td>
                          <td>***9364**</td>
                          <td className="text-primary">4,12</td>
                        </tr>
                        <tr>
                          <td>3º</td>
                          <td>López Vallejo, María</td>
                          <td>***3824**</td>
                          <td className="text-primary">2,43</td>
                        </tr>
                        <tr>
                          <td>4º</td>
                          <td>Rodríguez Justo, Estrella</td>
                          <td>***2493**</td>
                          <td className="text-primary">2,15</td>
                        </tr>
                        <tr>
                          <td>5º</td>
                          <td>Reinoso Flores, Gabriela</td>
                          <td>***4419**</td>
                          <td className="text-primary">0,33</td>
                        </tr>
                        <tr>
                          <td>6º</td>
                          <td>Pérez Lancho, Fernando</td>
                          <td>***4890**</td>
                          <td className="text-primary">0,20</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Aviso oficial de la resolución definitiva */}
                <div className="alert alert-success border-success">
                  <div className="d-flex align-items-start">
                    <FaCheckCircle className="me-3 mt-1 text-success" style={{fontSize: '1.2rem'}} />
                    <div>
                      <h6 className="alert-heading mb-2 fw-bold">
                        RESOLUCIÓN DEFINITIVA
                      </h6>
                      <p className="mb-0">
                        Se propone la contratación por orden decreciente cuando sea necesaria la cobertura de una interinidad, en la forma establecida en la Base 9ª.
                      </p>
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>

            {/* Criterios de valoración */}
            <Card className="info-card mb-4">
              <Card.Body>
                <h3><FaGraduationCap className="me-2" />Criterios de valoración de méritos</h3>
                <p className="mb-3">El proceso selectivo se realizará mediante concurso de méritos, con una puntuación máxima de 10 puntos.</p>
                
                <Accordion>
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>A. Experiencia profesional (hasta 8 puntos)</Accordion.Header>
                    <Accordion.Body>
                      <ul>
                        <li><strong>0,05 puntos</strong> por mes trabajado en puesto similar en Administración Pública</li>
                        <li><strong>0,03 puntos</strong> por mes trabajado en empresa privada o como autónomo en actividades equivalentes</li>
                        <li><strong>0,02 puntos</strong> por mes trabajado como Auxiliar de Clínica o Geriatría en centros públicos</li>
                        <li><strong>0,01 puntos</strong> por mes trabajado en empresas privadas del mismo ámbito</li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>
                  
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>B. Formación complementaria (hasta 2 puntos)</Accordion.Header>
                    <Accordion.Body>
                      <div className="formacion-criterios">
                        <h6>Cursos relacionados con el ámbito sociosanitario:</h6>
                        <p><strong>Homologados por entidad pública:</strong></p>
                        <ul>
                          <li>+100 horas: 1,00 punto</li>
                          <li>50–99 horas: 0,50 puntos</li>
                          <li>20–49 horas: 0,25 puntos</li>
                        </ul>
                        
                        <p><strong>No homologados (entidades privadas):</strong></p>
                        <ul>
                          <li>+100 horas: 0,40 puntos</li>
                          <li>50–99 horas: 0,20 puntos</li>
                          <li>20–49 horas: 0,10 puntos</li>
                        </ul>
                        
                        <div className="alert alert-info mt-2">
                          <small>No se valorarán cursos inferiores a 20 horas ni asignaturas universitarias.</small>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Card.Body>
            </Card>

          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default DetalleEmpleo;
